export default __webpack_public_path__ + "d28a0a1e1c5f8bbc1ee0e2655a5b37ca.png";